import { getNextIndex } from './getNextIndex';
import { normalizeKey } from './normalizeKey';

const INIT_ACTIVE_MENU = -1;

export const getKeyboardActions = ({
  closeMenu,
  menuItemCount,
  menuItemRefs,
}: {
  closeMenu: () => void;
  menuItemCount: number;
  menuItemRefs: React.MutableRefObject<Array<HTMLButtonElement | null>>;
}) => {
  let activeMenu = INIT_ACTIVE_MENU;

  const focusMenu = (index: number) => {
    if (menuItemRefs?.current && menuItemRefs.current[index]) {
      menuItemRefs.current[index].focus();
    }
  };

  const navigateMenu = ({
    direction,
    event,
  }: {
    direction: 'UP' | 'DOWN';
    event: React.KeyboardEvent<HTMLButtonElement>;
  }) => {
    // Prevent arrow keys scrolling the document while navigating the menu
    event.preventDefault();

    const nextIndex = getNextIndex({
      moveAmount: direction === 'UP' ? -1 : 1,
      current: activeMenu,
      total: menuItemCount,
    });

    focusMenu(nextIndex);

    activeMenu = nextIndex;
  };

  const resetActiveMenu = () => (activeMenu = INIT_ACTIVE_MENU);

  const KEY_DOWN_TO_ACTION: Record<
    string,
    (event: React.KeyboardEvent<HTMLButtonElement>) => void
  > = {
    Tab: () => {
      closeMenu();
      resetActiveMenu();
    },
    Escape: () => {
      closeMenu();
      resetActiveMenu();
    },
    ArrowUp: (event: React.KeyboardEvent<HTMLButtonElement>) => {
      navigateMenu({ direction: 'UP', event });
    },
    ArrowDown: (event: React.KeyboardEvent<HTMLButtonElement>) => {
      navigateMenu({ direction: 'DOWN', event });
    },
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    const targetKey = normalizeKey(event);

    if (
      targetKey === ' ' &&
      /firefox|iceweasel|fxios/i.test(navigator.userAgent)
    ) {
      return;
    }

    if (typeof KEY_DOWN_TO_ACTION[targetKey] === 'function') {
      KEY_DOWN_TO_ACTION[targetKey](event);
    }
  };
  return {
    onTriggerKeyDown: onKeyDown,
    onMenuItemKeyDown: onKeyDown,
  };
};
